import React, { useContext, useEffect } from 'react';
import LookerReport from '../../report/Looker';
import { buriedPoint, typeIdObj } from '@/pages/home/utils/buriedPoint';
import { StudioContext } from '../context';
import StudioState from '../components/StudioState';

const Looker = () => {
  const { currentGame, currentMenu, menuPermission } = useContext(StudioContext);
  const url = currentMenu?.url || '';
  const lookerModels = [currentMenu?.looker_models] || '';

  useEffect(()=> {
    if(!currentMenu){
      return;
    }

    const { game_code: gameCode } = currentGame;
    const { id = '', name_en: nameEn } = currentMenu || {};
    const logObj = {
      pageId: '101101', 
      menuId: id,
      pageName: nameEn,
      extInfo: nameEn,
      pagePath: `/looker/report/${nameEn || ''}`,
      uid: gameCode || '',
      typeId: typeIdObj.studio,
      gameName: currentGame?.game_name,
    };
    buriedPoint(logObj);

  },[currentGame, currentMenu]);

  if (menuPermission === false) {
    return <StudioState isNoPermission={true} />;
  }
  return (
    <>
      {
        url ? <LookerReport url={url} models={lookerModels} className='db-studio-iframe-wrap'/> : <StudioState/>
      }
    </>
  );
};

export default Looker;